import { render, staticRenderFns } from "./CambiarContrasenaComponent.vue?vue&type=template&id=d4f312b4&"
import script from "./CambiarContrasenaComponent.vue?vue&type=script&lang=js&"
export * from "./CambiarContrasenaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports